import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

const ApproveApplicant = ({ id }) => {
  const [, runMutation] = useMutation(workflowMutation)

  const handleSubmit = () => {
    runMutation({ id }).then(result => {
      if (result.error) {
        NotificationManager.error(result.error.message)
      }

      const { failures } = result.data.approveTutorApplication
      if (failures) {
        NotificationManager.error(failures.map(f => f.message).join(", "))
      } else {
        NotificationManager.success("Applicant approved")
      }
    })
  }

  return (
    <button className="btn btn-success" onClick={handleSubmit}>
      FINAL: Approve Applicant (this will generate their tutor account)
    </button>
  )
}

const workflowMutation = gql`
  mutation ($id: ID!) {
    approveTutorApplication(id: $id) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default ApproveApplicant
